import { createSlice, createAsyncThunk } from '@reduxjs/toolkit'
import { ExhibitionClient } from '@Pass-It-Down/exhibition-client'

const url = process.env.REACT_APP_SERVER_URL
const api = new ExhibitionClient({url})

export const loadExhibit = createAsyncThunk('exhibit/loadExhibit',
  async (id) => {
    const response = await api.exhibit().getShallowById(id)
    return response
  })

export const exhibitSlice = createSlice({
  name: 'exhibit',
  initialState: {
    loaded: false,
    exhibit: {
      name: "",
      mapZoom: 10,
      mapCenterAddressCoords: {lat: 0, lng: 0}
    },
  },
  extraReducers: {
    [loadExhibit.pending]: (state, action) => {
    },
    [loadExhibit.fulfilled]: (state, action) => {
      state.exhibit = action.payload
      state.loaded = true
    }
}})


export const selectExhibit = state => state.exhibit.exhibit

export const selectLoaded = state => state.exhibit.loaded

export const selectMapStyleName = state => state.exhibit.exhibit.mapStyle

export default exhibitSlice.reducer
